<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-warn m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate">{{
                data.titulo
            }}</span>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0"
        >{{ data.mensaje }}
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button [mat-dialog-close]="false">Cancelar</button>
        <button mat-raised-button color="accent" [mat-dialog-close]="true">
            Aceptar
        </button>
    </mat-dialog-actions>
</div>
